import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Physical Activity Participation and Sedentarism',
    subLabel: '',
    field: 'wlPhysicalFirst',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Over a typical seven-day period (one week), how many times do you engage in structured physical activity or an exercise session that is sufficiently prolonged and intense to cause sweating and a rapid heartbeat?',
          type: 'single_select',
          field: 'wlPhysicalEngagingPhysicalActivity',
          level: 'child',
          options: [
            { key: 'wlPhysicalEngagingPhysicalActivityMin3Times', value: 'At least three times' },
            { key: 'wlPhysicalEngagingPhysicalActivityOnceOrTwice', value: 'Normally once or twice' },
            { key: 'wlPhysicalEngagingPhysicalActivityRarelyOrNever', value: 'Rarely or never' }
          ]
        },
        {
          label: 'When you engage in structured physical activity or an exercise session, do you have the impression that you:',
          type: 'single_select',
          field: 'wlPhysicalActivityImpression',
          level: 'child',
          options: [
            { key: 'wlPhysicalActivityImpressionVigorous', value: 'Make a vigorous effort (e.g. jogging)' },
            { key: 'wlPhysicalActivityImpressionModerate', value: 'Make a moderate effort (e.g. brisk walking)' },
            { key: 'wlPhysicalActivityImpressionLight', value: 'Make a light effort (e.g. standing, light housework, shopping, light gardening)' }
          ]
        },
        {
          label: 'In a general fashion, would you say that your current physical fitness is:',
          type: 'single_select',
          field: 'wlPhysicalCurrentFitness',
          level: 'child',
          options: [
            { key: 'wlPhysicalCurrentFitnessVeryGood', value: 'Very Good' },
            { key: 'wlPhysicalCurrentFitnessGood', value: 'Good' },
            { key: 'wlPhysicalCurrentFitnessAverage', value: 'Average' },
            { key: 'wlPhysicalCurrentFitnessPoor', value: 'Poor' },
            { key: 'wlPhysicalCurrentFitnessVeryPoor', value: 'Very Poor' }
          ]
        },
        {
          label: 'Do you engage in Active Transport daily, such as walking or cycling to your job, school, shopping, social events, taking stairs wherever possible, etc.?',
          type: 'single_select',
          field: 'wlPhysicalActiveTransport',
          level: 'child',
          options: [
            { key: 'wlPhysicalActiveTransport yes', value: 'Yes' },
            { key: 'wlPhysicalActiveTransport no', value: 'No' }
          ]
        },
        {
          label: 'Do you engage in Daily Activities of Living such as house cleaning, moving the lawn, cooking, doing laundry, ironing, and light gardening for more than 2 hours a day at least 3 times each week?',
          type: 'single_select',
          field: 'wlPhysicalDailyActivities',
          level: 'child',
          options: [
            { key: 'wlPhysicalDailyActivities yes', value: 'Yes' },
            { key: 'wlPhysicalDailyActivities no', value: 'No' }
          ]
        },
        {
          label: 'Do you have an active job where you are standing or walking for most of your work shift?',
          type: 'single_select',
          field: 'wlPhysicalActiveJob',
          level: 'child',
          options: [
            { key: 'wlPhysicalActiveJob yes', value: 'Yes' },
            { key: 'wlPhysicalActiveJob no', value: 'No' }
          ]
        },
        {
          label: 'Do you Drive everywhere or use elevators and escalators regularly?',
          type: 'single_select',
          field: 'wlPhysicalDriveEverywhere',
          level: 'child',
          options: [
            { key: 'wlPhysicalDriveEverywhere yes', value: 'Yes' },
            { key: 'wlPhysicalDriveEverywhere no', value: 'No' }
          ]
        },
        {
          label: 'Do you have a sedentary occupation where you sit for the majority of your work day or more than 2 hours at a time?',
          type: 'single_select',
          field: 'wlPhysicalSedentaryOccupation',
          level: 'child',
          options: [
            { key: 'wlPhysicalSedentaryOccupation yes', value: 'Yes' },
            { key: 'wlPhysicalSedentaryOccupation no', value: 'No' }
          ]
        }
      ]
    }
  }
];
export default questionsModels;
